module.exports = __webpack_public_path__ + "static/media/fly0053.d06bb6e8.webp";